import React, { useState } from "react";
import { Link } from "react-router-dom";
import { IListObj } from "../types/genericTypes";
import "../../assets/scss/components/generic/navigationDropdown.scss";
import "../../assets/scss/components/generic/SecNavigation/secNavigationMobile.scss";

export interface INavigationDropdownProps {
	defaultValue?: number | string; // default selected value
	dropdownOptions: Array<IListObj>; // list of all options in dropdown
	onSelect: (id: string | number) => void; // the function to be called onSelect
	type: "page_nav" | "sec_nav"; // 'page_nav' if it is top nav. 'sec_nav' if it is secondary nav
}

const NavigationDropdown: React.FC<INavigationDropdownProps> = (props: INavigationDropdownProps) => {
	/**
	 * state and function for selectedValue
	 * selectedValue type is number | string
	 * setSelectedValue(number | string)
	 */
	const [selectedValue, setSelectedValue] = useState(props.defaultValue);

	/**
	 * state and function for isDropdownOpen
	 * selectedValue type is boolean
	 * setSelectedValue(boolean)
	 */
	const [isDropdownOpen, setIsDropdownOpen] = useState(false);

	/**
	 * called when user selects an option
	 * @param id id of the selected option
	 * @returns onSelect prop passed from parent
	 */
	function optionSelected(id: string | number) {
		setSelectedValue(id);
		setIsDropdownOpen(false);
		return props.onSelect(id);
	}

	React.useEffect(() => {
		setSelectedValue(props.defaultValue);
	}, [props]);
	return (
		<div className={"navigation_dropdown " + props.type}>
			<button className="dropdown_button" onClick={() => setIsDropdownOpen(true)}>
				{/* show the value of selectedValue */}
				<span className="selected">{props.dropdownOptions.find((option) => selectedValue === option.value)?.display}</span>
				<i className="arrow_down edel-icon-arrow-down" />
			</button>
			{/* when dropdown is open show overlay and content */}
			{isDropdownOpen && (
				<>
					{/* Overlay covers the whole screen. When overlay is clicked, close the dropdown. */}
					<div className="dropdown_overlay" onClick={() => setIsDropdownOpen(false)} />

					{/* Dropdown list */}
					<ul className="dropdown_content">
						{props.dropdownOptions.map((option) => (
							<li
								className={"dropdown_item" + (option.value === selectedValue ? " active" : "")}
								key={option.value}
								onClick={() => optionSelected(option.value)}
							>
								{/* show tick only if this option is selected */}
								{!option.href && option.display}
								{option.href && (
									<Link to={option.href}>
										<span className="tick_container">
											{option.value === selectedValue && <i className="tick edel-icon-tick" />}
										</span>

										<span>{option.display}</span>
									</Link>
								)}
							</li>
						))}
					</ul>
				</>
			)}
		</div>
	);
};

export default NavigationDropdown;
